var cov_1wxs0s0nlz = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/Item.tsx",
      hash = "c6882555ba57851d50fde7c87bc322cad641bb1c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 39
        },
        end: {
          line: 14,
          column: 49
        }
      },
      "1": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 54
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 13
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 28
          },
          end: {
            line: 16,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 28
          },
          end: {
            line: 16,
            column: 35
          }
        }, {
          start: {
            line: 16,
            column: 39
          },
          end: {
            line: 16,
            column: 53
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 58
          }
        }, {
          start: {
            line: 16,
            column: 62
          },
          end: {
            line: 16,
            column: 72
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/Item.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { carouselClass } from './styles';

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      cov_1wxs0s0nlz.f[0]++;

      var _ref = (cov_1wxs0s0nlz.s[0]++, this.props),
          children = _ref.children,
          current = _ref.current,
          pre = _ref.pre;

      var className = (cov_1wxs0s0nlz.s[1]++, classnames(carouselClass('item', (cov_1wxs0s0nlz.b[0][0]++, current) && (cov_1wxs0s0nlz.b[0][1]++, 'item-current'), (cov_1wxs0s0nlz.b[1][0]++, pre) && (cov_1wxs0s0nlz.b[1][1]++, 'item-pre')), this.props.className));
      cov_1wxs0s0nlz.s[2]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 19,
            columnNumber: 12
          }
        }, children)
      );
    }
  }]);

  return Item;
}(PureComponent);

export default Item;